import BaseController from "../pages/sharedControllers/BaseController";
import { Specification } from "../models/Specification";
import Event from "sap/ui/base/Event";
import Token from "sap/m/Token";
import Tokenizer from "sap/m/Tokenizer";

export function onSelectWorkOrder(controller: BaseController) {
  const model = controller.getModel();
  const specification: Specification = model.getData();

  const workOrders =
    controller.getModelData<Record<string, unknown>[]>("workOrders");
  if (workOrders) {
    specification.workOrderIds = [];
    specification.totalAmount = 0;
    let selected = false;
    workOrders.forEach((wo) => {
      if (wo["selected"] && wo["workOrderId"] && (!wo["specificationId"] || wo["specificationId"] === specification.specificationId) && wo["status"] === "closed") {
        selected = true;
        specification.workOrderIds?.push(wo["workOrderId"] as number);
        specification.totalAmount =
          (specification.totalAmount || 0) +
          (wo["amount"] ? (wo["amount"] as number) : 0);
      } else if (
        !wo["selected"] &&
        wo["workOrderId"] &&
        wo["status"] === "closed" &&
        (!wo["specificationId"] || wo["specificationId"] === specification.specificationId)
      ) {
        const workOrderOptionsModel = controller.getModel("workOrdersOptions");
        const workOrderOptions: { selectAll: boolean } =
          workOrderOptionsModel.getData();
        workOrderOptionsModel.setData({
          ...workOrderOptions,
          selectAll: false,
        });
      }

      updateMainContractNumber(controller, wo, selected);
    });
  }
  model.setData(specification);
}

export function onSelectAllWorkOrders(
  controller: BaseController,
  event: Event
) {
  const isSelected = event.getParameter("selected" as never) as boolean;

  const model = controller.getModel();
  const specification: Specification = model.getData();

  const workOrdersModel = controller.getModel("workOrders");
  const workOrders: Record<string, unknown>[] = workOrdersModel.getData();

  if (workOrders) {
    specification.workOrderIds = [];
    specification.totalAmount = 0;
    workOrders.forEach((wo) => {
      // TODO: Check if status is ok (not closed wo should be ignroed)
      wo["selected"] = wo["status"] === "closed" && (!wo["specificationId"] || wo["specificationId"] === specification.specificationId) && isSelected;
      if (
        isSelected &&
        wo["workOrderId"] &&
        wo["status"] === "closed" &&
        (!wo["specificationId"] || wo["specificationId"] === specification.specificationId)
      ) {
        specification.workOrderIds?.push(wo["workOrderId"] as number);
        specification.totalAmount =
          (specification.totalAmount || 0) +
          (wo["amount"] ? (wo["amount"] as number) : 0);

        updateMainContractNumber(controller, wo, isSelected);
      } else {
        updateMainContractNumber(controller, wo, false);
      }
    });
  }

  workOrdersModel.setData(workOrders);
  model.setData(specification);
}

export function updateMainContractNumber(controller: BaseController, workOrder: Record<string, unknown>, selected = false, contractsNameListId = "contractsNameList") {
  const contractsTokenizer = controller.byId(contractsNameListId) as Tokenizer;
  const mainContractNumber = workOrder.mainContractNumber as string;

  if (contractsTokenizer && mainContractNumber) {
    const token = contractsTokenizer.getTokens().find(t => t.getKey() === mainContractNumber);
    if (selected) {
      if (token === null || token === undefined) {
        contractsTokenizer.addToken(new Token({
          key: mainContractNumber,
          text: mainContractNumber,
        }));
      }
    } else {
      if (token) {
        contractsTokenizer.removeToken(token);
      }
    }
  }
}
